import { FC } from 'react'

import { Box, Skeleton } from '@mui/material'

/**
 * Neutral page-level placeholder shown by `UAInsightsNavigationProvider` while
 * the (large) UA Insights dataset chunk is still downloading — before either
 * the dashboard or the game page has mounted. Because the provider wraps both
 * entry points, this skeleton stays deliberately generic: a sticky-header-like
 * control row followed by a few content blocks. Once the data is ready, each
 * page swaps in its own layout-matched skeleton (`DashboardSkeleton` /
 * `GamePageBodySkeleton`), so this only ever covers the brief boot window and
 * replaces the previous full-page spinner.
 */
export const UAInsightsBootSkeleton: FC = () => (
  <Box>
    {/* Header control row (selectors + search / actions). */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: -2.3, pt: 1.5, pb: 1.5, mb: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Skeleton variant="rounded" width={120} height={40} />
      <Skeleton variant="rounded" width={120} height={40} />
      <Skeleton variant="rounded" sx={{ flex: 1 }} height={40} />
      <Skeleton variant="rounded" width={120} height={40} />
    </Box>

    {/* Generic content blocks. */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} variant="rounded" height={92} sx={{ borderRadius: 1 }} />
        ))}
      </Box>
      {[0, 1].map((i) => (
        <Skeleton key={i} variant="rounded" height={220} sx={{ borderRadius: 1 }} />
      ))}
    </Box>
  </Box>
)
